import React from "react";
import { useIntl } from "react-intl";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { Input } from "react_reusable_components";

export default function AddCounterMeasureContainer({
  className,
  onChange,
  value,
}) {
  const intl = useIntl();
  return (
    <Input
      className={className}
      placeholder={getLocalizedMessage(
        intl,
        "manageAudit.F2F.addCounterMeasurePlaceholder"
      )}
      value={value}
      onChange={onChange}
    />
  );
}
